class PlannerAPIService {

    constructor(configuration) {
        this.brand = configuration.brand;
        this.base = configuration.serverUrl + '/api';
        this.helper = new APIHelper(this.base)
    }

    fetchUniversityData(handler) {
        this.helper.get('/university/' + this.brand + '/?t=' + new Date().getTime(), {
            onResult: handler,
            cache: true
        });
    }

    requestPrint(key, printContent, handler) {
        this.helper.post('/print_request/'+key+'/', {
            jsonData: {
                'html': printContent,
                'base': window.location.href
            },
            onResult: handler,
        })
    }

    registerForLiveSession(plannerType, key, data, handler) {
        this.helper.post('/live_session_register/'+plannerType+'/'+this.brand+'/'+key, {
            jsonData: data,
            onResult: handler
        });
    }

    loadProfile(guid, handler) {
        
    }
}
